import { ButtonProps } from 'antd';
import * as React from 'react';
import { SimilInputSpan } from '../../../../../ui/form/SimilInputSpan';
import { $SpaceCompact } from '../../../../../ui/form/SpaceCompact';
import { ExpressionType } from '../../../IExpression';
import { IReference } from '../../../references/IReference';
import { AssignableExpressionInput } from '../../assignable/input/AssignableExpressionInput';
import { IAsyncService } from '../context/IAsyncService';

export interface IAsyncServiceInputsInputProps {
  name: string;
  service: IAsyncService;
  references: IReference[];
  size?: ButtonProps['size'];
  style?: React.CSSProperties;
  disableInput?: (input: string) => boolean;
}

export function AsyncServiceInputsInput(props: IAsyncServiceInputsInputProps) {
  const { service, references, name, size } = props;

  return (
    <>
      {service.inputs.map((input, index) => (
        <div key={input.name} style={{ marginBottom: '8px' }}>
          <$SpaceCompact block size={size}>
            <SimilInputSpan>{input.name}</SimilInputSpan>
            <AssignableExpressionInput
              size="large"
              block
              allowedTypes={[ExpressionType.Value, ExpressionType.Reference]}
              references={references}
              name={`${name}[${input.name}]`}
              field={input.type}
              // Accetto sia campi numerici che stringhe come reference di input ai params di un servizio
              allowsReference={reference =>
                reference.field.type === input.type.type
              }
              disabled={props.disableInput?.(input.name)}
            />
          </$SpaceCompact>
        </div>
      ))}
    </>
  );
}
